import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Nursery/Mathematics";
import { Helmet } from "react-helmet";

const Mathematics: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery - Mathematics"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Explore fun and interactive nursery math activities on Mamas Guidance—designed to help young children develop early number sense, counting, shapes, and basic math skills through engaging and age-appropriate exercises.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default Mathematics;